export function PageHeader({ eyebrow, title, lede, right }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8 md:mb-10">
      <div className="min-w-0">
        {eyebrow && <div className="label-caps mb-2 truncate">{eyebrow}</div>}
        <h1 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1] tracking-tight break-words">
          {title}
        </h1>
        {lede && (
          <p className="mt-3 text-sm md:text-base text-muted-foreground max-w-2xl">{lede}</p>
        )}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}

export function Section({ title, eyebrow, right, children, testId }) {
  return (
    <section data-testid={testId} className="mt-10 md:mt-14">
      <div className="flex items-end justify-between gap-3 mb-4">
        <div className="min-w-0">
          {eyebrow && <div className="label-caps mb-1.5 truncate">{eyebrow}</div>}
          {title && (
            <h2 className="font-display text-xl md:text-2xl tracking-tight truncate">{title}</h2>
          )}
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
      <div className="hairline-t" />
      <div className="pt-5">{children}</div>
    </section>
  );
}
